<nb-card>
  <nb-card-header>{{ 'games.report.report_score' | translate }}</nb-card-header>
  <nb-card-body>
    <form id="report-game-form" [formGroup]="reportGameForm">
      <div [nbSpinner]="loading()"
           nbSpinnerStatus="danger"
           nbSpinnerSize="large"
           nbSpinnerMessage="">
        <table class="match-table">
          <tbody>
            <tr class="match-teams">
              <td class="left">{{ match.team_1_name }}</td>
              <td class="dash"></td>
              <td class="right">{{ match.team_2_name }}</td>
            </tr>
            <tr class="match-score">
              <td class="left">
                <nb-select id="team_1_score" formControlName="team_1_score">
                  @for (scoreOption of scoreOptions(); track scoreOption.code) {
                    <nb-option [value]="scoreOption.code">{{scoreOption.name}}</nb-option>
                  }
                </nb-select>
              </td>
              <td class="dash">-</td>
              <td class="right">
                <nb-select id="team_2_score" formControlName="team_2_score">
                  @for (scoreOption of scoreOptions(); track scoreOption.code) {
                    <nb-option [value]="scoreOption.code">{{scoreOption.name}}</nb-option>
                  }
                </nb-select>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Screenshots désactivés
        <div
          class="upload-zone"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
          [class.dragover]="isDragOver">
            <svg class="upload-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="upload-title">UPLOAD MATCH SCREENSHOTS <span class="upload-optional">(optional)</span></p>
            <p class="upload-subtitle">Drag and drop files here</p>
            <input
              #fileInput
              type="file"
              multiple
              accept="image/*"
              (change)="onFileSelect($event)"
              style="display: none"
            />
          </div>

          @if(selectedFiles.length > 0) {
            <div class="files-list">
              @for(file of selectedFiles; track file.name; let i = $index) {
                <div class="file-item">
                  <span>{{ file.name }}</span>
                  <button (click)="removeFile(i)" class="remove-btn">×</button>
                </div>
              }
            </div>
          }
        Fin screenshots désactivés -->

        <div
          class="upload-zone"
          (dragover)="onVideoDragOver($event)"
          (dragleave)="onVideoDragLeave($event)"
          (drop)="onVideoDrop($event)"
          (click)="videoInput.click()"
          [class.dragover]="isVideoDragOver">
            <svg class="upload-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M15 10l4.553-2.276A1 1 0 0 1 21 8.723v6.554a1 1 0 0 1-1.447.894L15 14M3 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="upload-title">{{ 'games.report.upload_video' | translate }}</p>
            <p class="upload-subtitle">mkv, avi, mp4, mov, wmv — max {{ videoSettings().max_size_mb }} MB — max {{ videoSettings().max_duration_seconds }}s</p>
            <input
              #videoInput
              type="file"
              multiple
              [accept]="videoAccept()"
              (change)="onVideoSelect($event)"
              style="display: none"
            />
          </div>

          @if(selectedVideos.length > 0) {
            <div class="files-list">
              @for(video of selectedVideos; track video.name; let i = $index) {
                <div class="file-item">
                  <span>{{ video.name }}</span>
                  <button (click)="removeVideo(i)" class="remove-btn">×</button>
                </div>
              }
            </div>
          }
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer>
    @if (uploadProgress() !== null) {
      <div style="margin-bottom: 12px;">
        <p style="text-align:center; margin-bottom: 6px; font-weight: bold;">{{ 'games.report.uploading' | translate }} {{ uploadProgress() }}%</p>
        <nb-progress-bar [value]="uploadProgress()!" status="primary" size="large" [displayValue]="true"></nb-progress-bar>
      </div>
    }
    <div class="form-buttons">
      <button nbButton status="danger" size="large" (click)="onCancel()" [disabled]="uploadProgress() !== null">{{ 'common.cancel' | translate }}</button>
      <button nbButton status="primary" size="large" (click)="onSubmit()" [disabled]="!reportGameForm.valid || selectedVideos.length === 0 || uploadProgress() !== null">{{ 'common.submit' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
